import React, { useState, useEffect } from "react";
import stylesInput from "../../styles/Atoms/InputCampaing/campaing";

const InputCampaings = ({
  label,
  value,
  onChange,
  width,
  height,
  color,
  colorSelect,
  errorText,
  validate,
  type = 'text'
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [validationError, setValidationError] = useState("");

  
  useEffect(() => {
    if (validate) {
      const error = validate(value);
      setValidationError(error || "");
    }
  }, [value, validate]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setValidationError("");

    if (onChange) {
      onChange(inputValue);
    }
  };


  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    if (!value) {
      setIsFocused(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          ...stylesInput.div,
          color: color,
        }}
      >
        <label
          style={{
            ...stylesInput.label,
            color: isFocused ? colorSelect : color,
            transform:
              isFocused || value ? "translateY(0)" : "translateY(-50%)",
            top: isFocused || value ? "-5px" : "65%",
          }}
        >
          {label}
        </label>
      </div>
      <div>
        <input
          type={type}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          style={{
            ...stylesInput.input,
            width: width || "100%",
            height: height || "2rem",
            boxShadow: isFocused ? '0px 4px 8px rgba(0, 0, 0, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.2)', 
            '&:hover': {
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)', 
            },
          }}
          error={!!validationError || !!errorText}
        />
      </div>
    </div>
  );
};

export default InputCampaings;
